import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { Analytics } from 'common-frontend'
import { ExtendedUserSource } from 'sources'
import { API_BASE } from 'consts'

@createActions(alt)
export default class OnboardingActions {
  constructor() {
    this.generateActions(
      'setTrialAccepted'
    )
  }

  determineIfUserShouldSelectPlan(token) {
    return ExtendedUserSource.fetchCurrent(token)
      .then(user => {
        if (user.shouldSelectPlan) {
          window.location.replace(`${API_BASE}/v3ui/pricing`)
        }
      });
  }

  trialAccepted(accepted) {
    this.setTrialAccepted(accepted)
    if (accepted === true) {
      Analytics.track('Trial accepted') // of course this doesn't mean they accept the application charge
    } else {
      Analytics.track('Trial declined') // ...similarly they can still start a trial from the Plus tab
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./app/actions/OnboardingActions.js